export const isTransactionPage = (pathname: string) => {
  const sections = pathname.split('/')
  return (
    sections[1] === 'accounts' &&
    sections[3] === 'transactions' &&
    // Regular transaction: /accounts/[account]/transactions/[transaction]
    (sections.length === 6 ||
      // Inbound transaction: /accounts/[account]/transactions/inbound/[transaction]
      (sections.length === 7 && sections[4] === 'inbound'))
  )
}
